import {useTranslation} from '@aboutyou/i18n';
import {COLORS, FONT_SIZES, FONT_WEIGHTS} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {CountryFlag} from './CountryFlag';

export const CountriesOpenerContent: FC<{
  className?: string;
  countryFlagSrc: string;
  countryLabel: string;
  Icon?: React.ReactNode;
}> = ({className, countryFlagSrc, countryLabel, Icon}) => {
  const {t} = useTranslation();

  return (
    <Wrapper
      className={className}
      data-testid={`languageCountrySwitchCountriesOpenerContent`}
    >
      <Title>{t('Current Shop')}</Title>
      <CountryWrapper>
        <Flag src={countryFlagSrc} />
        <Label
          data-testid={`languageCountrySwitchCountriesOpenerContentLabel-${countryLabel}`}
        >
          {countryLabel}
        </Label>
        {Icon}
      </CountryWrapper>
    </Wrapper>
  );
};

const sharedFontStyles = css`
  color: ${COLORS.Black};
  font-size: ${FONT_SIZES.px14};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  margin-bottom: 2px;
`;

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const Title = styled.span`
  ${sharedFontStyles};
`;

const CountryWrapper = styled.div`
  align-items: center;
  display: flex;
`;

const Flag = styled(CountryFlag)`
  margin-right: 0.5rem;
`;

const Label = styled.span`
  ${sharedFontStyles};
`;
